var _path, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 67,
    viewBox: "0 0 70 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.606 42.106L39.09 37.59M41.4538 31.8832C41.4538 27.4259 37.8405 23.8125 33.3832 23.8125C28.9259 23.8125 25.3125 27.4259 25.3125 31.8832C25.3125 36.3405 28.9259 39.9538 33.3832 39.9538C37.8405 39.9538 41.4538 36.3405 41.4538 31.8832Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4942_260311)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4942_260311",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.5322 41.4729C57.8428 37.9325 58.26 34.1235 57.7469 30.3833C57.2338 26.6431 55.8062 23.0872 53.5906 20.0305C51.3749 16.9738 48.4396 14.5107 45.0447 12.8594C41.6498 11.2081 37.9 10.4196 34.1276 10.5636C30.3551 10.7076 26.6764 11.7798 23.4172 13.6852C20.1581 15.5905 17.4192 18.2702 15.4431 21.487C13.4669 24.7037 12.3146 28.3581 12.0882 32.1265C11.8618 35.895 12.5682 39.6611 14.1449 43.0913L16.2682 42.1153C14.852 39.0343 14.2174 35.6515 14.4208 32.2667C14.6242 28.8819 15.6592 25.5994 17.4342 22.7102C19.2091 19.8209 21.6693 17.4139 24.5966 15.7025C27.524 13.9911 30.8283 13.0281 34.2167 12.8987C37.6052 12.7693 40.9732 13.4776 44.0226 14.9608C47.0719 16.4441 49.7084 18.6564 51.6985 21.4019C53.6886 24.1475 54.9709 27.3414 55.4318 30.7009C55.8926 34.0604 55.5179 37.4816 54.3407 40.6617L56.5322 41.4729Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.5322 41.4729C57.8428 37.9325 58.26 34.1235 57.7469 30.3833C57.2338 26.6431 55.8062 23.0872 53.5906 20.0305C51.3749 16.9738 48.4396 14.5107 45.0447 12.8594C41.6498 11.2081 37.9 10.4196 34.1276 10.5636C30.3551 10.7076 26.6764 11.7798 23.4172 13.6852C20.1581 15.5905 17.4192 18.2702 15.4431 21.487C13.4669 24.7037 12.3146 28.3581 12.0882 32.1265C11.8618 35.895 12.5682 39.6611 14.1449 43.0913L16.2682 42.1153C14.852 39.0343 14.2174 35.6515 14.4208 32.2667C14.6242 28.8819 15.6592 25.5994 17.4342 22.7102C19.2091 19.8209 21.6693 17.4139 24.5966 15.7025C27.524 13.9911 30.8283 13.0281 34.2167 12.8987C37.6052 12.7693 40.9732 13.4776 44.0226 14.9608C47.0719 16.4441 49.7084 18.6564 51.6985 21.4019C53.6886 24.1475 54.9709 27.3414 55.4318 30.7009C55.8926 34.0604 55.5179 37.4816 54.3407 40.6617L56.5322 41.4729Z",
    stroke: "#A4D8C1",
    strokeWidth: 3,
    shapeRendering: "crispEdges",
    mask: "url(#path-2-inside-1_4942_260311)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4942_260311)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_4942_260311",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.2828 46.613C67.4393 41.6329 68.3343 36.1979 67.8885 30.7894C67.4427 25.3808 65.67 20.1657 62.7273 15.6059C59.7846 11.0462 55.7628 7.28248 51.0181 4.64829C46.2734 2.0141 40.9523 0.590709 35.5261 0.504194C30.0999 0.417679 24.7361 1.67071 19.9099 4.1523C15.0836 6.63389 10.9438 10.2674 7.85727 14.7311C4.7707 19.1947 2.8326 24.3507 2.21464 29.7423C1.59668 35.1339 2.31794 40.5946 4.31452 45.6409L6.56649 44.7499C4.71643 40.074 4.0481 35.014 4.62071 30.0181C5.19332 25.0222 6.98919 20.2446 9.84923 16.1085C12.7093 11.9724 16.5452 8.60556 21.0173 6.30609C25.4894 4.00662 30.4595 2.84554 35.4875 2.92571C40.5154 3.00587 45.446 4.32481 49.8425 6.76568C54.239 9.20654 57.9657 12.694 60.6924 16.9192C63.4192 21.1443 65.0618 25.9767 65.4748 30.9883C65.8879 35.9999 65.0586 41.0361 63.0604 45.6506L65.2828 46.613Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.2828 46.613C67.4393 41.6329 68.3343 36.1979 67.8885 30.7894C67.4427 25.3808 65.67 20.1657 62.7273 15.6059C59.7846 11.0462 55.7628 7.28248 51.0181 4.64829C46.2734 2.0141 40.9523 0.590709 35.5261 0.504194C30.0999 0.417679 24.7361 1.67071 19.9099 4.1523C15.0836 6.63389 10.9438 10.2674 7.85727 14.7311C4.7707 19.1947 2.8326 24.3507 2.21464 29.7423C1.59668 35.1339 2.31794 40.5946 4.31452 45.6409L6.56649 44.7499C4.71643 40.074 4.0481 35.014 4.62071 30.0181C5.19332 25.0222 6.98919 20.2446 9.84923 16.1085C12.7093 11.9724 16.5452 8.60556 21.0173 6.30609C25.4894 4.00662 30.4595 2.84554 35.4875 2.92571C40.5154 3.00587 45.446 4.32481 49.8425 6.76568C54.239 9.20654 57.9657 12.694 60.6924 16.9192C63.4192 21.1443 65.0618 25.9767 65.4748 30.9883C65.8879 35.9999 65.0586 41.0361 63.0604 45.6506L65.2828 46.613Z",
    stroke: "#A4D8C1",
    strokeWidth: 3,
    shapeRendering: "crispEdges",
    mask: "url(#path-3-inside-2_4942_260311)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4942_260311",
    x: 10.0469,
    y: 10.5469,
    width: 49.9141,
    height: 36.5469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4942_260311"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4942_260311",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4942_260311",
    x: 0,
    y: 0.5,
    width: 70,
    height: 50.1094,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4942_260311"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4942_260311",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8b298db7888ce82da964d8d4d328ad8a.svg";
export { ForwardRef as ReactComponent };